import { Component, Room, Transform } from '../../SavaneJS';
import { TemporaryEntity } from './TemporaryEntity';

/**
 * TemporaryRoom is used for room edition
 */
export class TemporaryRoom extends TemporaryEntity {
    public height: number;
    public floorHeight: number;
    public hasPlinths: boolean;
    public plinthsHeight: number;
    public plinthsMaterialType: number;
    public cornicesMaterialType: number;
    public hasCornices: boolean;
    public cornicesHeight: number;
    public cornicesDepth: number;
    public components: Array<Component> = [];
    private _transform: Transform;

    constructor(room: Room) {
        super(room);

        // Room height
        this.height = room.height;
        // and room floor height (can be negative)
        this.floorHeight = room.floorHeight;

        // Plinths parameters
        this.hasPlinths = room.plinths;
        this.plinthsHeight = room.plinthsHeight;
        // Material type is an enum (number)
        this.plinthsMaterialType = room.plinthsMaterialType;
        this.cornicesMaterialType = room.cornicesMaterialType;

        // Cornices or not
        this.hasCornices = room.cornices;
        this.cornicesHeight = room.cornicesHeight;
        this.cornicesDepth = room.cornicesDepth;

        room.components.forEach((item) => {
            let clone = item.clone();
            clone.entity = room;
            this.components.push(clone);
        });

        this._transform = new Transform(null);
        this._transform.clone(room.transform);
    }

    computeValidity() {
        this._isValid = true;
    }

    get transform(): Transform {
        return this._transform;
    }
}
